import { TipoRecapitoAnagrafeEnum } from "@app/shared/enum/tipo-recapito-anagrafe-enum";
import { TipoSoggettoAnagrafeEnum } from "@app/shared/enum/tipo-soggetto-anagrafe-enum";

export class EntitaAnagrafeVO {
  idRecapito: string;
  idSoggetto: string;
  denominazioneSoggetto: string;
  denominazioneRecapito: string;
  tipoRecapito: TipoRecapitoAnagrafeEnum;
  tipo: TipoRecapitoAnagrafeEnum;
  tipoSoggetto: TipoSoggettoAnagrafeEnum;
  codiceSoggetto: string; // p.IVA o codFis
  descrizioneRecapito: string;
  soggettoPadre: EntitaAnagrafeVO;
  statoSoggetto: string;
  listaSoggettiRecapito: EntitaAnagrafeVO[];
}
